import React from "react";
import { useForm, ValidationError } from "@formspree/react";

function BookingForm() {
  const [state, handleSubmit] = useForm("xzzdvwbd");

  if (state.succeeded) {
    return <p className="text-green-600">Thanks — your booking request was sent.</p>;
  }

  const times = ["10:00 AM", "1:00 PM", "3:00 PM", "5:00 PM"];

  return (
    <form
      onSubmit={handleSubmit}
      className="max-w-lg mx-auto p-6 bg-white shadow-md rounded-lg space-y-4"
    >
      <div>
        <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
          Name
        </label>
        <input
          id="name"
          type="text"
          name="name"
          required
          className="w-full p-3 border border-gray-300 rounded-md"
        />
      </div>

      <div>
        <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
          Email
        </label>
        <input
          id="email"
          type="email"
          name="email"
          required
          className="w-full p-3 border border-gray-300 rounded-md"
        />
        <ValidationError prefix="Email" field="email" errors={state.errors} className="text-red-500 text-xs mt-1" />
      </div>

      <div>
        <label htmlFor="date" className="block text-sm font-medium text-gray-700 mb-1">
          Date
        </label>
        <input
          id="date"
          type="date"
          name="date"
          required
          min={new Date().toISOString().split("T")[0]}
          className="w-full p-3 border border-gray-300 rounded-md"
        />
      </div>

      <div>
        <label htmlFor="time" className="block text-sm font-medium text-gray-700 mb-1">
          Time
        </label>
        <select
          id="time"
          name="time"
          required
          className="w-full p-3 border border-gray-300 rounded-md"
        >
          <option value="">Select a time</option>
          {times.map((time) => (
            <option key={time} value={time}>
              {time}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
          Notes
        </label>
        <textarea
          id="message"
          name="message"
          rows="4"
          className="w-full p-3 border border-gray-300 rounded-md"
        />
        <ValidationError prefix="Message" field="message" errors={state.errors} className="text-red-500 text-xs mt-1" />
      </div>

      <button
        type="submit"
        disabled={state.submitting}
        className="w-full px-4 py-3 bg-[#007FFF] text-white rounded-2xl shadow-md hover:bg-[#339CFF] disabled:opacity-50"
      >
        {state.submitting ? "Sending..." : "Book Appointment"}
      </button>
    </form>
  );
}

export default BookingForm;